import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  inject
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CompositionProductVariantSummaryDTO } from 'src/app/admin-api';
import { getEquityLabel } from 'src/app/models';
import { DiamanteVermelhoLookupService } from 'src/app/services/diamante-vermelho-lookup.service';
import { ProductKitLookupService } from 'src/app/services/product-kit-lookup.service';
import {
  SUBSCRIBER_RESERVED_LABEL,
  isSubscriberReservedProduct,
  subscriberReservedTooltip
} from 'src/app/utils/composition-product-reservation.util';

@Component({
  selector: 'app-composition-product-detail',
  templateUrl: './composition-product-detail.component.html',
  styleUrls: ['./composition-product-detail.component.scss']
})
export class CompositionProductDetailComponent
  implements OnInit, OnChanges, OnDestroy
{
  private readonly diamanteVermelhoLookup = inject(
    DiamanteVermelhoLookupService
  );
  private readonly productKitLookup = inject(ProductKitLookupService);
  private lookupSubscription: Subscription | undefined;

  @Input()
  product: CompositionProductVariantSummaryDTO | undefined;

  @Input()
  index: number | undefined;

  diamanteVermelhoLabel: string | undefined;
  isKit = false;
  kitTooltip: string | undefined;
  subscriberReserved = false;
  subscriberReservedTooltip: string | undefined;
  readonly subscriberReservedLabel = SUBSCRIBER_RESERVED_LABEL;

  ngOnInit(): void {
    this.lookupSubscription = new Subscription();
    this.lookupSubscription.add(
      this.diamanteVermelhoLookup.updated$.subscribe(() =>
        this.refreshDiamanteVermelhoLabel()
      )
    );
    this.lookupSubscription.add(
      this.productKitLookup.updated$.subscribe(() => this.refreshKit())
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product']) {
      this.diamanteVermelhoLookup.enqueue([this.product?.productVariantId]);
      this.productKitLookup.enqueue([this.product?.productVariantId]);
      this.refreshDiamanteVermelhoLabel();
      this.refreshKit();
      this.refreshSubscriberReserved();
    }
  }

  ngOnDestroy(): void {
    this.lookupSubscription?.unsubscribe();
  }

  equityLabel(equity: number): string {
    return getEquityLabel(equity);
  }

  private refreshDiamanteVermelhoLabel(): void {
    const label = this.diamanteVermelhoLookup.labelFor(
      this.product?.productVariantId
    );
    this.diamanteVermelhoLabel = label || undefined;
  }

  private refreshKit(): void {
    const lookup = this.productKitLookup.lookupFor(
      this.product?.productVariantId
    );
    this.isKit = !!lookup?.isKit;
    const names = (lookup?.components || [])
      .map((component) => {
        const qty = component.quantity ? ` x${component.quantity}` : '';
        return `${component.productVariantName || component.millenniumSKU || component.productVariantId}${qty}`;
      })
      .filter(Boolean);
    this.kitTooltip = names.length ? names.join(', ') : 'Produto kit';
  }

  private refreshSubscriberReserved(): void {
    this.subscriberReserved = isSubscriberReservedProduct(this.product);
    this.subscriberReservedTooltip =
      subscriberReservedTooltip(this.product) || undefined;
  }
}
